var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBxCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83331 9.66663H7.49998V11.3333H5.83331V9.66663ZM5.83331 13H7.49998V14.6666H5.83331V13ZM9.16665 9.66663H10.8333V11.3333H9.16665V9.66663ZM9.16665 13H10.8333V14.6666H9.16665V13ZM12.5 9.66663H14.1666V11.3333H12.5V9.66663ZM12.5 13H14.1666V14.6666H12.5V13Z",
    fill: "#A6B0CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16667 18.8333H15.8333C16.7525 18.8333 17.5 18.0858 17.5 17.1666V7.16663V5.49996C17.5 4.58079 16.7525 3.83329 15.8333 3.83329H14.1667V2.16663H12.5V3.83329H7.5V2.16663H5.83333V3.83329H4.16667C3.2475 3.83329 2.5 4.58079 2.5 5.49996V7.16663V17.1666C2.5 18.0858 3.2475 18.8333 4.16667 18.8333ZM15.8333 7.16663L15.8342 17.1666H4.16667V7.16663H15.8333Z",
    fill: "#A6B0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxCalendar);
export default __webpack_public_path__ + "static/media/bx-calendar.c7e3ecf6.svg";
export { ForwardRef as ReactComponent };